import { AbilityBuilder } from "@casl/ability";
import { defineAbility } from "@casl/ability";
import { User } from "../../../app/modules/apps/user-management/users-list/core/_models";

export function updateAbility(ability : any, user : any) {
  const { can, rules } = new AbilityBuilder(user);
  const userRoles = user?.roleDetail;
  Object.entries(userRoles.permissions)?.forEach(([subject, value] : any) => {
    Object?.entries(value)?.forEach(([i, action]) => {
      let cond = "";
      can(action, subject, cond);
    });
  });
  ability.update(rules);
}

export default defineAbility((can, cannot) => {
    can('read', 'Dashboard')
  })